import React from "react";
import { Link } from "react-router-dom";

function PageTitle({ page, setTab }) {
  return (
    <div className="ttm-page-title-row">
      <div className="ttm-page-title-row-inner ttm-bgcolor-darkgrey">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-title-heading">
                <h2 className="title">{page}</h2>
              </div>
              <div className="breadcrumb-wrapper">
                <span>
                  <i className="fa fa-home mr-2"></i>
                  <Link to="/" onClick={() => setTab("home")}>
                    Home
                  </Link>
                </span>
                <span className="ttm-bread-sep">&nbsp; :&nbsp;: &nbsp;</span>
                <span>{page}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageTitle;
